"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getProdViewTemplate = function getProdViewTemplate() {
  return {
    productViews: {
      value: 1
    },
    _telus: {
      customProductViews: {
        value: 1
      }
    }
  };
};
var _default = exports["default"] = getProdViewTemplate;